<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Overdue Returns
        <small>Rentals past their due date</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">Reports</a> /
        <span class="current">Overdue Returns</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-primary" (click)="exportData()"><i class="bi bi-download"></i> Export</button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-clock-history" style="color:#ef4444;"></i>
        <h2>Overdue Returns</h2>
        <span class="report-badge danger">{{ overdue().length }} items</span>
      </div>
    </div>
    <div class="report-body">
      <div class="overdue-list">
        @for (item of overdue(); track item.id) {
          <div class="overdue-item" [class]="severityClass(overdueDays(item.dueDate))">
            <span class="overdue-asset">{{ item.equipment }}</span>
            <span class="overdue-days">{{ overdueDays(item.dueDate) }} days</span>
            <span class="overdue-funeral">{{ item.checkoutNumber }}</span>
          </div>
        } @empty {
          <p class="report-empty">No overdue returns for {{ dateRange.appliedLabel() }}.</p>
        }
      </div>
      <div class="report-footer">
        <span>{{ overdue().length }} overdue for {{ dateRange.appliedLabel() }}</span>
      </div>
    </div>
  </div>
</div>
